import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { eur, num, showMoney } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";

const monthLabel = (m) => {
  const [y, mo] = m.split("-");
  return new Date(y, mo - 1).toLocaleDateString("it-IT", { month: "short", year: "2-digit" });
};

const startOfWindow = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 11, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
};

export const ReturnsTrend = () => {
  const { data } = useQuery({
    queryKey: ["returns-trend"],
    queryFn: async () => (await api.get("/sales/returns", { params: { date_from: startOfWindow() } })).data,
  });
  const rows = (data?.by_month || []).map((m) => ({ ...m, label: monthLabel(m.month) }));
  const money = showMoney();

  return (
    <Card className="mt-6 p-6" data-testid="resi-trend-card">
      <h3 className="mb-1 font-display text-lg font-semibold">Andamento mensile dei resi</h3>
      <p className="mb-4 text-xs text-muted-foreground">
        Ultimi 12 mesi, per mese dell'ordine. Gli ultimi mesi possono crescere ancora: i resi arrivano qualche settimana dopo la spedizione.
      </p>
      <ResponsiveContainer width="100%" height={280}>
        <ComposedChart data={rows}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="label" stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} />
          {money && <YAxis yAxisId="eur" stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} tickFormatter={(v) => `€${Math.round(v / 1000)}k`} />}
          <YAxis yAxisId="pct" orientation="right" stroke="hsl(var(--muted-foreground))" fontSize={12} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}%`} />
          <Tooltip
            contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 13 }}
            formatter={(v, name, p) => (name === "Valore rimborsato"
              ? [`${eur(v)} · ${num(p.payload.units)} pz`, name]
              : [`${num(v)}% (${num(p.payload.units)}/${num(p.payload.shipped_units)} pz)`, name])}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} payload={money ? undefined : [{ value: "Tasso di reso", type: "line", color: "hsl(var(--primary))" }]} />
          {money && <Bar yAxisId="eur" dataKey="amount" name="Valore rimborsato" fill="#fb7185" radius={[4, 4, 0, 0]} />}
          <Line yAxisId="pct" type="monotone" dataKey="rate" name="Tasso di reso" stroke="hsl(var(--primary))" strokeWidth={2} dot />
        </ComposedChart>
      </ResponsiveContainer>
    </Card>
  );
};
